export const CONFIG = {
     SENTRY_DSN: "https://4571ea19de550ff2419b4576966ae348@o363881.ingest.us.sentry.io/4507334710132736",
     SENTRY_ORG: "shapediver",
     SENTRY_PROJECT: "app-builder",
     SENTRY_RELEASE_TIMESTAMP: "2026-09-14_08:12"
}; 